import { createAction, props } from '@ngrx/store';

const GET_ORGMANAGEMENT = '[OrgManagement] Get OrgManagement';
const GET_ORGMANAGEMENT_SORTING = '[OrgManagement] Get OrgManagement With Sorting';
const SET_ORGMANAGEMENT = '[OrgManagement] Set OrgManagement';
const SET_ORGMANAGEMENT_SORTING = '[OrgManagement] Set OrgManagement With Sorting';
const CLEAR_TEXT = '[OrgManagement] Clear Text';
const SENT_ORGMANAGEMENT = '[OrgManagement] Sent OrgManagement';
const SAVE_ORGMANAGEMENT = '[OrgManagement] Save OrgManagement';
const UPDATE_ORGMANAGEMENT = '[OrgManagement] Update OrgManagement';
const STORE_GIT_TOKEN = '[OrgManagement] Store Git Token';
const DELETE_ORGMANAGEMENT = '[OrgManagement] Delete OrgManagement';
const SENT_DELETE_ORGMANAGEMENT = '[OrgManagement] Sent Delete OrgManagement';
const GET_SID_BASED_ORGMANAGEMENT = '[OrgManagement] Get SID Based OrgManagement';
const SET_SID_BASED_ORGMANAGEMENT = '[OrgManagement] Set SID Based OrgManagement';
const GET_ORGMANAGEMENT_BASED_SEARCH = '[OrgManagement] Get OrgManagement Based Search';
const ERROR_MESSAGE = '[OrgManagement] Error Message OrgManagement';
const TEST_GIT_CONNECTION = '[OrgManagement] Test Git Connection OrgManagement';
const TEST_GIT_CONNECTION_COMPLETE = '[OrgManagement] Test Git Connection Complete';
const GET_ORGLIST_HEADER = '[OrgManagement] Get OrgManagement For Header';
const SET_ORGLIST_HEADER = '[OrgManagement] Set OrgManagement For Header';
const GET_ORGDATA = '[OrgManagement] Get Org data';
const SET_ORGDATA = '[OrgManagement] Set Org data';
const GET_APPS_BASED_USERS = '[OrgManagement] Get App For Users';
const SET_APPS_BASED_USERS = '[OrgManagement] Set App For Users';
const ACTIVATE_ORG = '[OrgManagement] Activate Organization';
const DEACTIVATE_ORG = '[OrgManagement] Deactivate Organization';
const DELETE_ORGMANAGEMENT_SUCCESS = '[OrgManagement] Delete Organization Successful';
const DELETE_ORGMANAGEMENT_FAILURE = '[OrgManagement] Delete Organization Failed';
const getOrgManagement = createAction(GET_ORGMANAGEMENT, props<{ apiConstants: any; filter: any }>());

const getOrgManagementWithSorting = createAction(
  GET_ORGMANAGEMENT_SORTING,
  props<{ apiConstants: any; filter: any }>()
);

const setOrgManagement = createAction(SET_ORGMANAGEMENT, props<{ organizationData: any; totalRecords: any }>());

const setAppForUsers = createAction(
  SET_APPS_BASED_USERS,
  props<{
    sidAppData: any;
  }>()
);
const setOrgManagementWithSorting = createAction(
  SET_ORGMANAGEMENT_SORTING,
  props<{ organizationData: any; totalRecords: any }>()
);

const getErrorMessage = createAction(ERROR_MESSAGE, props<{ errorMessage: any }>());

const sentOrgManagement = createAction(SENT_ORGMANAGEMENT, props<{ apiConstants: any; saveorganizationData: any }>());

const clearSearchText = createAction(CLEAR_TEXT, props<{ searchText: any }>());

const saveOrgManagement = createAction(SAVE_ORGMANAGEMENT, props<{ organizationData: any }>());

const getAppForUsers = createAction(
  GET_APPS_BASED_USERS,
  props<{
    apiConstants: any;
    params: any;
  }>()
);

const updateOrgManagement = createAction(UPDATE_ORGMANAGEMENT, props<{ organizationData: any }>());

const storeGitToken = createAction(STORE_GIT_TOKEN, props<{ apiConstants: any; gitToken: any }>());

const deleteOrgManagement = createAction(
  DELETE_ORGMANAGEMENT,
  props<{ apiConstants: any; organizationId: string; orgName: string; selectedOrg: string }>()
);

const deleteOrgManagementSuccess = createAction(
  DELETE_ORGMANAGEMENT_SUCCESS,
  props<{ organizationId: string; selectedOrg: string }>()
);

const deleteOrgManagementFailure = createAction(DELETE_ORGMANAGEMENT_FAILURE, props<{ organizationId: string }>());

const activateOrganization = createAction(ACTIVATE_ORG, props<{ apiConstants: any; organizationId: string }>());

const deactivateOrganization = createAction(
  DEACTIVATE_ORG,
  props<{ apiConstants: any; organizationId: string; selectedOrg: string }>()
);

const setOrgDelorDeactiveState = createAction(
  DEACTIVATE_ORG,
  props<{ organizationId: string; selectedOrgDeleted: any }>()
);

const sentDeleteOrgManagement = createAction(
  SENT_DELETE_ORGMANAGEMENT,
  props<{ apiConstants: any; organizationId: string; orgName: string }>()
);

const getSidBasedOrManagement = createAction(
  GET_SID_BASED_ORGMANAGEMENT,
  props<{
    apiConstants: any;
    sid: any;
  }>()
);
const setSidBasedOrManagement = createAction(
  SET_SID_BASED_ORGMANAGEMENT,
  props<{
    sidOrgManagementData: any;
  }>()
);

const getOrManagementBasedOnSearch = createAction(
  GET_ORGMANAGEMENT_BASED_SEARCH,
  props<{ apiConstants: any; searchFields: any }>()
);

const testGitConnection = createAction(TEST_GIT_CONNECTION, props<{ apiConstants: any; testGitToken: any }>());
const testGitConnectionComplete = createAction(TEST_GIT_CONNECTION_COMPLETE);
const getOrglistforHeader = createAction(
  GET_ORGLIST_HEADER,
  props<{ apiConst: any; searchText: string; searchQuery: any }>()
);

const getOrgDataForHeader = createAction(
  SET_ORGLIST_HEADER,
  props<{
    orgApi: any;
    sid: any;
  }>()
);
const setOrglistforHeader = createAction(GET_ORGDATA, props<{ orglistForHeader: any; searchText: any }>());

const setOrgDataForHeader = createAction(
  SET_ORGDATA,
  props<{
    orgDataForHeader: any;
  }>()
);

export {
  getOrgManagement,
  saveOrgManagement,
  updateOrgManagement,
  storeGitToken,
  deleteOrgManagement,
  setOrgManagement,
  sentOrgManagement,
  setAppForUsers,
  clearSearchText,
  sentDeleteOrgManagement,
  getSidBasedOrManagement,
  setSidBasedOrManagement,
  getOrManagementBasedOnSearch,
  getErrorMessage,
  testGitConnection,
  testGitConnectionComplete,
  setOrgManagementWithSorting,
  getOrgManagementWithSorting,
  getOrglistforHeader,
  getOrgDataForHeader,
  setOrglistforHeader,
  setOrgDataForHeader,
  getAppForUsers,
  activateOrganization,
  deactivateOrganization,
  deleteOrgManagementSuccess,
  deleteOrgManagementFailure,
  setOrgDelorDeactiveState
};
